import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Input, Form, Button, Select, notification, Flex } from 'antd';
import { jwtDecode } from 'jwt-decode';

import { exception } from '@extensions/notification';

import { useAppDispatch } from '@store/hooks';
import { userLoaded } from '@store/actions';
import { isNewYearAroundUs } from '@extensions/utils';
import { getEnumList, tryParseJson } from '@extensions/utils';

import { IUserSession } from '@entities/user-session';
import { IContact } from '@entities/contact';

import { UserType } from '@enums/user-type';
import { BusinessUnit, enumLabel } from '@enums/business-unit';
import { IEnumItem } from '@enums/enum-item';

import { MainLogoIcon } from '@icons/index';

import GooglePlay from '@assets/img/google-play-badge.png';
import GooglePlayQr from '@assets/img/GooglePlayQr.png';
import AppStoreQr from '@assets/img/AppStoreQr.png';

import MaxCuttingBotQr from '@assets/svg/MaxCuttingBotQr.svg';
import MaxPlantingBotQr from '@assets/svg/MaxPlantingBotQr.svg';
import TelegramCuttingBotQr from '@assets/svg/TelegramCuttingBotQr.svg';
import TelegramPlantingBotQr from '@assets/svg/TelegramPlantingBotQr.svg';
import Telegram from '@assets/svg/Telegram.svg';
import WhatsApp from '@assets/svg/WhatsApp.svg';
import AppStore from '@assets/svg/app-store-badge.svg';

import { serverFetch } from '@core/server';

import '@core/auth.css';

const flcApiBaseUrl = process.env.REACT_APP_FLC_API_BASE_URL;

interface IAuth {
    appVersion: string | undefined;
}

interface IAuthParams {
    businessUnit: BusinessUnit;
    login: string;
    password: string;
}

const Auth = (props: IAuth) => {
    const { appVersion } = props;

    const navigate = useNavigate();

    const d = useAppDispatch();

    const [form] = Form.useForm();
    const businessUnit = Form.useWatch<BusinessUnit>('businessUnit', form);

    const [api, contextHolder] = notification.useNotification();

    const [loading, setLoading] = useState<boolean>(false);
    const [systemSupport, setSystemSupport] = useState<IContact>();

    const [businessUnits] = useState<Array<IEnumItem>>(getEnumList(BusinessUnit, enumLabel));

    useEffect(() => {
        const storedBusinessUnit = localStorage.getItem('businessUnit');
        if (storedBusinessUnit) {
            const businessUnit: BusinessUnit = +storedBusinessUnit as BusinessUnit;
            form.setFieldValue('businessUnit', businessUnit);
        }

        getSystemSupport();

        document.addEventListener('keydown', onKeyDown, false);
        return () => {
            document.removeEventListener('keydown', onKeyDown, false);
            close();
        };
    }, []);

    const getSystemSupport = () => {
        serverFetch(flcApiBaseUrl, undefined, `contacts/systemsupport`, { method: 'GET' })
            .then((data) => {
                setSystemSupport(data);
            })
            .catch((ex) => {
                exception(api, 'Ошибка получения контакта технической поддержки', ex, () => d(userLoaded(undefined)));
            });
    };

    const onKeyDown = (e: any) => {
        if (e.keyCode === 13) {
            //signInForm.submit();
        }
    };

    const close = () => {
        setLoading(false);
        form.resetFields();
    };

    const onFinish = (entity: IAuthParams) => {
        setLoading(true);

        const data = {
            businessUnit: entity.businessUnit,
            login: entity.login,
            password: entity.password,
            isWeb: true,
        };

        serverFetch(flcApiBaseUrl, undefined, `auth/carriersignin`, { method: 'POST', bodyData: data, credentials: 'include' })
            .then((data) => {
                window.accessToken = data.accessToken;

                localStorage.setItem('refreshToken', data.refreshToken);

                const result: any = jwtDecode(data.accessToken);

                let storedBusinessUnit = localStorage.getItem('businessUnit');
                if (!storedBusinessUnit || +storedBusinessUnit != result.businessUnit) {
                    localStorage.setItem('businessUnit', result.businessUnit as any);
                    navigate('/');
                }

                console.log("result13",result);
                

                const userSession: IUserSession = {
                    businessUnit: result.businessUnit,
                    userId: result.id,
                    fullName: result.fullName,
                    type: +result.type as UserType,
                    permissions: tryParseJson(result.permissions),
                    userSettings: tryParseJson(result.userSettings),

                    resetPasswordRequired: data.resetPasswordRequired,
                    isDemo: data.isDemo,

                    useTagRequired: result.useTagRequired == 'True',
                    tag: result.tag,
                };

                d(userLoaded(userSession));
                close();
            })
            .catch((ex) => {
                setLoading(false);
                exception(api, 'Ошибка авторизации', ex, () => d(userLoaded(undefined)));
            });
    };

    return (
        <div>
            <div className='auth'>
                <Flex className='auth-container' vertical justify='space-between' align='center'>
                    <div className='auth-form'>
                        <div className='auth-logo'>
                            {isNewYearAroundUs() && <div className='santa-hat-auth'></div>}
                            <MainLogoIcon style={{ fontSize: 64 }} />
                        </div>
                        <div className='auth-form-title'>Кабинет перевозчика</div>

                        <Form size={'large'} form={form} initialValues={{ remember: true }} onFinish={onFinish}>
                            <Form.Item
                                name='login'
                                rules={[{ required: true, message: 'Пожалуйста введите логин' }]}
                                hasFeedback
                                className='auth-form-item'
                            >
                                <Input name='login' placeholder='Логин' disabled={loading} className='auth-form-item-input' />
                            </Form.Item>
                            <Form.Item
                                name='password'
                                className='auth-form-item'
                                rules={[{ required: true, message: 'Пожалуйста введите пароль' }]}
                                hasFeedback
                            >
                                <Input.Password
                                    name='password'
                                    placeholder={'Пароль'}
                                    disabled={loading}
                                    className='auth-form-item-input'
                                />
                            </Form.Item>
                            <Form.Item style={{ marginBottom: 0 }}>
                                <Button type='primary' htmlType='submit' loading={loading} className='auth-form-btn'>
                                    Войти
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>

                    <div className='auth-app-version'>Версия {appVersion}</div>
                </Flex>

                {contextHolder}
            </div>
        </div>
    );
};

export default Auth;
